import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Stack, Text } from '@tonic-ui/react';
import { useTranslation, Trans } from 'react-i18next';
import { useStorageState } from '../../hooks/useStorageState';
import { gotoSignIn, isGovCloudRegion } from '../../utils/helpers';
import { AuthContext } from '../../context/AuthContext';

const deploymentTarget =
  DEPLOYMENT_TARGET === 'prod'
    ? ''
    : DEPLOYMENT_TARGET === 'stage'
    ? 'staging-'
    : DEPLOYMENT_TARGET === 'drsim'
    ? 'drsim-'
    : DEPLOYMENT_TARGET === 'dev' || 'alpha'
    ? 'dev-'
    : '';

interface stateType {
  location: { name: string; email: string; result: Record<string, string> };
}

const Confirmation = (): JSX.Element => {
  const [refererUrl, setRefererUrl] = useState('');
  const [, setSignInPreference] = useStorageState('localStorage', 'C1C_SIGN_IN_METHOD', 'ws');

  const { t } = useTranslation();
  const history = useHistory<stateType>();
  const { eventDistributor } = useContext(AuthContext);
  const {
    location: { state = {} },
  } = history;
  const { name = '', email = '', result = {} } = state;

  useEffect(() => {
    const findReferrerCookie =
      document.cookie.length > 1 &&
      document.cookie.split('; ').find((cookie) => cookie.startsWith('_c1Ref'));
    const referrerPathname = findReferrerCookie ? findReferrerCookie.split('_c1Ref=')[1] : '';

    setRefererUrl(`${document.referrer}${decodeURIComponent(referrerPathname.slice(1))}`);
  }, []);

  useEffect(() => {
    if (name === '' || email === '') {
      gotoSignIn(eventDistributor);
    }
  }, [name, email]);

  useEffect(() => {
    // make sure that the correct tab gets shown on the login page
    setSignInPreference('cognito');
  }, []);

  return (
    <Stack
      justifyContent="center"
      spacing="5x"
      maxWidth={700}
      margin="128px auto"
      fontSize="lg"
      lineHeight="lg"
      fontWeight={300}
    >
      <Text>
        {t('thanks')} {name}.
      </Text>

      {result.userConfirmed ? (
        <Stack spacing="5x">
          <Text>
            <Trans i18nKey="signUpConfirmation.userAccountCreated" />
          </Text>
          <Text>
            <Trans i18nKey="signUpConfirmation.invitationConfirmationMessage" />
          </Text>
          <Box margin="0 auto">
            <Button
              variant="primary"
              onClick={() => {
                // redirect them to login page with email pre-populated
                // TODO prepopulate the URL and refresh the header
                history.push('/', { email });
              }}
            >
              <Trans i18nKey="signUpConfirmation.getStartedMessage" />
            </Button>
          </Box>
        </Stack>
      ) : (
        <Stack spacing="5x">
          <Text>
            <Trans i18nKey="signUpConfirmation.message" values={{ email: email }} />
          </Text>
          <Text>{t('signUpConfirmation.linkExpireMessage')}</Text>
        </Stack>
      )}
      {!isGovCloudRegion && (
        <iframe
          frameBorder="0"
          width="1"
          height="1"
          name="confirmation"
          id="c1c_tealium_iframe"
          src={`https://tsm.${deploymentTarget}cloudone.trendmicro.com/_auth/static-${BUILD_TIMESTAMP}/assets/tealium/index.html?referrer=${refererUrl}&url=${document.URL}`}
        />
      )}
    </Stack>
  );
};

export default Confirmation;
